import "./Navigation";
import "./SwiperGalleries";
import ScrollToTop from "./ScrollToTop";
import PlausibleEvents from "./PlausibleEvents";
import "./MembershipDialog";
import "./DonateDialog";
import "./PartnerFilter";
import "./Accordion";
import "./Calendar";
import "./Groups";
import "./Gallery";
import "./Newsletter";
import Map from "./map/Map";
import { PartnerMobileHover } from "./PartnerMobileHover";
import { Search } from "./Search";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

const backToTopButton = document.querySelector<HTMLElement>("#BackToTop");
if (backToTopButton) {
    new ScrollToTop(backToTopButton);
}

new Map();
new PlausibleEvents();
new PartnerMobileHover();
new Search();
